import Point from '../../Utility/Point';
import Element from '../../Prototype/UI/Element';
import * as PIXI from 'pixi.js';
import '@sgorg/pixi-ui';
import Game from '../../Game';
import UIComponent from '../UI/UIComponent';

export default class UITextComponent extends UIComponent {
    public UIComponent: PIXI.ui.component.Text;
    private _bounds: Point;
    private _style: PIXI.TextStyleOptions;

    public attach(gameObject: Element, params: any): void {
        let text: string;
        if (params.data.textLocalizationKey) {
            try {
                text = Game.locale.getText(params.data.textLocalizationKey);
            } catch {
                text = params.data.textLocalizationKey;
            }
        } else if (params.data.text) {
            text = params.data.text;
        }

        const style: any =
            typeof params.data.style === 'string' ? Game.style.getStyle(params.data.style) : params.data.style;

        // FIXME: don't mutate arguments!

        if (style.style) style.fontStyle = style.style;
        if (style.font) style.fontFamily = style.font;

        delete style.style;
        delete style.font;

        this._style = style;

        this.UIComponent = new PIXI.ui.component.Text(text, {
            ...style,
            align: params.data.align,
            wordWrap: params.data.wordWrap,
            wordWrapWidth: params.data.wordWrapWidth,
        });

        gameObject.container.add(this.UIComponent);

        if (params.data.bounds) {
            this.bounds = new Point(params.data.bounds[0], params.data.bounds[1]);
        }

        super.attach(gameObject, params);
    }

    get text(): string {
        return this.UIComponent.text;
    }

    set text(value: string) {
        this.UIComponent.text = value;
        this.recalculateSize();
    }

    get style(): PIXI.TextStyleOptions {
        return this.UIComponent.PIXIText.style;
    }

    set style(style: PIXI.TextStyleOptions) {
        this.UIComponent.textStyleOptions = style;

        Object.keys(style).forEach((key: keyof PIXI.TextStyleOptions) => {
            this.UIComponent.PIXIText.style[key] = style[key] as never;
        });

        this._style = style;
        this.recalculateSize();
    }

    recalculateSize(): void {
        // Calculate the bounds first
        this.bounds = this.bounds;

        // Then resize the container
        this.container.desiredWidth = this.UIComponent.PIXIText.width;
        this.container.desiredHeight = this.UIComponent.PIXIText.height;
        this.container.resize(0, 0);
    }

    set bounds(value: Point) {
        // Validate.
        if (!value || value.x <= 0 || value.y <= 0) return;

        this._bounds = value;

        // Get original font size
        let fontSize = parseInt(this._style.fontSize as string) - 1;
        if (isNaN(fontSize)) {
            console.log(`Failed to set bounds; Font size in NaN`);
            return;
        }
        // Set text to original font size
        this.UIComponent.PIXIText.style.fontSize = fontSize;

        // Reduce size until get a fitable size is found.
        for (fontSize > 0; fontSize--; ) {
            const metrics = PIXI.TextMetrics.measureText(
                this.UIComponent.PIXIText.text,
                this.UIComponent.PIXIText.style,
                this.UIComponent.PIXIText.style.wordWrap
            );
            if (metrics.width > value.x || metrics.height > value.y) {
                this.UIComponent.PIXIText.style.fontSize = fontSize;
            } else {
                break;
            }
        }
    }

    get bounds() {
        return this._bounds;
    }
}
